import { Link } from 'react-router-dom';
import { moments } from '@/mocks/moments';
import { formatCount } from '@/utils/format';

export default function HotRanking() {
  const ranked = [...moments].sort((a, b) => b.views - a.views).slice(0, 5);
  const [featured, ...rest] = ranked;

  if (!featured) {
    return null;
  }

  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 text-sm text-accent-700">
            <i className="ri-fire-line"></i>
            本周热搜
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">人气名场面榜单</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl">
            按观看量排序的前五条,每一条都标注了最值得看的关键画面节点。
          </p>
        </div>
        <Link
          to="/moments"
          className="self-start md:self-auto px-5 py-2.5 rounded-md text-sm whitespace-nowrap bg-secondary-500 text-foreground-950 hover:bg-secondary-600 transition-colors cursor-pointer"
        >
          查看完整榜单
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <article className="relative rounded-lg overflow-hidden bg-background-50 border border-background-200">
          <Link to={`/moment/${featured.id}`} className="block cursor-pointer">
            <div className="relative w-full h-64 md:h-80 overflow-hidden bg-background-200">
              <img
                src={featured.cover}
                alt={`${featured.title} 封面图`}
                title={`${featured.title} · 私拍吃瓜名场面`}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center rounded-md bg-accent-500 text-background-50 font-heading text-2xl">
                1
              </span>
            </div>
            <div className="p-6">
              <span className="text-xs text-primary-700">{featured.category}</span>
              <h3 className="mt-2 font-heading text-2xl text-foreground-950">{featured.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
              <div className="mt-4 flex items-center gap-5 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {formatCount(featured.views)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-heart-3-line"></i>
                  {formatCount(featured.likes)}
                </span>
              </div>
            </div>
          </Link>
        </article>

        <ul className="flex flex-col gap-3">
          {rest.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/moment/${item.id}`}
                className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-800 font-heading text-lg">
                  {index + 2}
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading text-base text-foreground-950 truncate">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500 truncate">{item.summary}</p>
                </div>
                <span className="ml-auto hidden sm:flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
                  <i className="ri-eye-line"></i>
                  {formatCount(item.views)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}